import { PatternFormat as NumberFormat } from 'react-number-format';

export const PhoneNumberFormatDisplay = ({ value, prefix }: { value: string | number; prefix?: string }) => {
  return <NumberFormat value={value} format='(###) ###-####' displayType={'text'} prefix={prefix} />;
};
